// extracted by mini-css-extract-plugin
export default {"auth0Plus":"AddNewItem_auth0Plus__tpmtY","buttonContainer":"AddNewItem_buttonContainer__S1Tt9","dropboxChooser":"AddNewItem_dropboxChooser__a5XGL"};